<div class="weather-chart-container">
  <div
    [attr.tabindex]="collapsible ? 0 : null"
    class="weather-header"
    [attr.role]="collapsible ? 'button' : null"
    [attr.aria-expanded]="collapsible ? expanded : null"
    [class.is-collapsible]="collapsible"
    (click)="toggleExpanded()"
    (keydown.enter)="toggleExpanded()"
    (keydown.space)="$event.preventDefault(); toggleExpanded()"
  >
    <div class="weather-title">
      <h3>{{ title }}</h3>
      @if (location) {
        <span class="weather-location">{{ location }}</span>
      }
    </div>
    <div *ngIf="temperatureSummary.current !== null || humiditySummary.current !== null" class="weather-summary">
      <div class="summary-item">
        <span class="summary-label">{{ 'DASHBOARD.WEATHER_NOW' | translate }}</span>
        <span class="summary-value">{{ temperatureSummary.current !== null ? (temperatureSummary.current | number: '1.0-1') : '--' }}°C</span>
        <span class="summary-sub" matTooltip="{{ 'DASHBOARD.WEATHER_HUMIDITY' | translate }}">
          <mat-icon aria-hidden="true" class="humidity-icon">water_drop</mat-icon>
          {{ humiditySummary.current !== null ? (humiditySummary.current | number: '1.0-0') : '--' }}%
        </span>
      </div>
      <div class="summary-item">
        <span class="summary-label">{{ 'DASHBOARD.WEATHER_MIN' | translate }}</span>
        <span class="summary-value">{{ temperatureSummary.min !== null ? (temperatureSummary.min | number: '1.0-1') : '--' }}°C</span>
        <span class="summary-sub" matTooltip="{{ 'DASHBOARD.WEATHER_HUMIDITY' | translate }}">
          <mat-icon aria-hidden="true" class="humidity-icon">water_drop</mat-icon>
          {{ humiditySummary.min !== null ? (humiditySummary.min | number: '1.0-0') : '--' }}%
        </span>
      </div>
      <div class="summary-item">
        <span class="summary-label">{{ 'DASHBOARD.WEATHER_MAX' | translate }}</span>
        <span class="summary-value">{{ temperatureSummary.max !== null ? (temperatureSummary.max | number: '1.0-1') : '--' }}°C</span>
        <span class="summary-sub" matTooltip="{{ 'DASHBOARD.WEATHER_HUMIDITY' | translate }}">
          <mat-icon aria-hidden="true" class="humidity-icon">water_drop</mat-icon>
          {{ humiditySummary.max !== null ? (humiditySummary.max | number: '1.0-0') : '--' }}%
        </span>
      </div>
      <div class="summary-item">
        <span class="summary-label" matTooltip="{{ 'DASHBOARD.WEATHER_THI_TOOLTIP' | translate }}">
          {{ 'DASHBOARD.WEATHER_THI' | translate }}
        </span>
        <span class="summary-value">{{ thiSummary.current !== null ? (thiSummary.current | number: '1.0-1') : '--' }}</span>
        <span class="summary-sub">{{ 'DASHBOARD.WEATHER_MAX' | translate }} {{ thiSummary.max !== null ? (thiSummary.max | number: '1.0-1') : '--' }}</span>
      </div>
      <div class="summary-item">
        <span class="summary-label">{{ 'DASHBOARD.WEATHER_RAIN' | translate }}</span>
        <span class="summary-value">{{ precipitationSummary.maxProbability !== null ? (precipitationSummary.maxProbability | number: '1.0-0') : '--' }}%</span>
        <span class="summary-sub">{{ 'DASHBOARD.WEATHER_MAX_CHANCE' | translate }}</span>
      </div>
    </div>

    <!-- Compact loading indicator for the collapsed header. When expanded, the body below shows its
         own (larger) spinner, so this is gated on !expanded to avoid two spinners at once. -->
    @if (isLoading && !expanded) {
      <div aria-live="polite" class="weather-header-loading">
        <mat-spinner diameter="20"></mat-spinner>
      </div>
    }

    @if (collapsible) {
      <mat-icon aria-hidden="true" class="weather-toggle-icon">{{ expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
    }
  </div>

  @if (!collapsible || expanded) {
    @if (isLoading) {
      <div class="weather-loading">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
    } @else if (labels.length > 0) {
      @if (precipitationStrip.length > 0) {
        <div class="precipitation-strip">
          <div class="strip-label">{{ 'DASHBOARD.WEATHER_PRECIPITATION' | translate }}</div>
          <div
            class="strip-bars"
            [style.gridTemplateColumns]="precipitationGridTemplate"
            [style.paddingLeft.px]="precipitationPaddingLeft + precipitationOffsetPx"
            [style.paddingRight.px]="precipitationPaddingRight + precipitationRightOffsetPx"
            [style.width.%]="precipitationStripWidth"
          >
            @for (bar of precipitationStrip; track bar.index) {
              <div
                class="strip-bar"
                [style.opacity]="bar.opacity"
                [style.width.%]="precipitationBarWidth"
                [attr.title]="bar.label + '–' + bar.endLabel + ': ' + (bar.probability | number: '1.0-0') + '%'"
              ></div>
            }
          </div>
        </div>
      }
      <div aria-label="THI stress legend" class="thi-legend">
        <span class="thi-legend-title">{{ 'DASHBOARD.WEATHER_THI_SCALE' | translate }}</span>
        <div class="thi-legend-items">
          @for (item of thiLegend; track item.labelKey) {
            <span class="thi-legend-item">
              <span class="thi-legend-swatch" [style.backgroundColor]="item.color" [style.borderColor]="item.borderColor"></span>
              <span class="thi-legend-label">{{ item.labelKey | translate }}</span>
            </span>
          }
        </div>
      </div>
      <div class="weather-chart-wrapper">
        <canvas type="line" [data]="lineChartData" [options]="lineChartOptions" [plugins]="[hourGridPlugin]" baseChart></canvas>
      </div>
    } @else {
      <div class="weather-empty">Weather data unavailable.</div>
    }
  }
</div>
